export default __webpack_public_path__ + "assets/images/96272f914c7cd840595f889ca6f38ffd.jpg";